<!-- 最新信号 -->
<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <p class="title">最新信号</p>

    <div class="lsmx" ref="lsmx">
      <div class="fc-title-sticky">
        <van-sticky
          :offset-top="tabsHeight + headerHeight + zxxgThHeight - 2"
          z-index="97"
          :container="lsmx"
        >
          <ul class="title">
            <li v-if="$route.query.yzType">
              {{ $route.query.yzType == 'ETF' ? 'ETF名称' : '股票名称' }}
            </li>

            <li v-if="Obj.type_info">
              {{ Obj.type_info == 2 ? 'ETF名称' : '股票名称' }}
            </li>
            <li>最新</li>
            <li>涨幅</li>
            <li>涨跌</li>
            <li>操作</li>
          </ul>
        </van-sticky>
      </div>

      <ul
        class="content-list"
        v-for="(item, index) in StockPoolsResult.List"
        :key="index"
        @click.stop="gogufs(item.StockCode)"
      >
        <li>
          <p class="StockName">{{ item.StockName }}</p>
          <p class="StockCode">{{ removePrefix(item.StockCode) }}</p>
        </li>

        <li>
          {{ hqList[item.StockCode] ? toFixedNum(hqList[item.StockCode].ZuiXinJia, 2) : '--' }}
        </li>
        <li :class="hqList[item.StockCode] ? [judgeColor(hqList[item.StockCode].ZhangFu)] : ''">
          {{ hqList[item.StockCode] ? toFixedNum(hqList[item.StockCode].ZhangFu, 2, '%') : '--' }}
        </li>
        <li>
          {{ hqList[item.StockCode] ? toFixedNum(hqList[item.StockCode].ZhangDie, 2) : '--' }}
        </li>
        <li>
          <button
            class="del_btn"
            v-if="MyZxStock.includes(item.StockCode) || addStockList.includes(item.StockCode)"
          >
            已加入
          </button>
          <button class="add_btn" v-else @click.stop="handleClickAddBtn(item.StockCode, index)">
            加自选
          </button>
        </li>
      </ul>

      <van-empty
        description="暂无数据"
        v-if="!StockPoolsResult.List"
        :image="require('@/assets/image/notData.png')"
      />
    </div>
  </div>
</template>

<script>
import { insertStockByGroup, getMyZxStockInfo } from '@/api/index.js';
import { getStockHq } from '@/api/create';

import { judgeColor, toFixedNum, formatStrTime, dateFormat, fangDouFun } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Zxxg',
  mixins: [mixin],
  props: ['StockPoolsResult', 'headerHeight', 'tabsHeight'],
  data() {
    return {
      zxxgThHeight: 0,
      hqList: [],
      lsmx: null,
      MyZxStock: [],
      addStockList: [],
      type_info: 1
    };
  },
  filters: {},
  created() {},
  //计算属性
  computed: {
    Obj: function () {
      return this.$store.state.Obj; // 获取全局状态
    }
  },
  watch: {},
  async mounted() {
    await this.getStockHqFun();
    this.getMyOptional();
    this.lsmx = this.$refs.lsmx;
  },
  methods: {
    judgeColor,
    toFixedNum,
    formatStrTime,
    dateFormat,
    getStockHqFun: function () {
      var stockCodes = []; // 用于存储 StockCode 的数组

      if (this.StockPoolsResult.List) {
        this.StockPoolsResult.List.forEach(function (item) {
          stockCodes.push(item.StockCode);
        });
      }
      var params = {
        stockID: stockCodes.toString()
      };
      getStockHq(params)
        .then((res) => {
          if (res.err === 200) {
            this.hqList = res.data;
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    // 获取我的自选股
    getMyOptional: function () {
      getMyZxStockInfo({}).then((res) => {
        if (res.err === 200) {
          this.MyZxStock = res.data.Stocks;
        }
      });
    },
    handleClickAddBtn: fangDouFun(function (...args) {
      this.addStock(...args);
    }, 300),
    // 加自选
    addStock: function (StockCode) {
      let obj = {
        stocks: StockCode
      };
      insertStockByGroup(obj).then((res) => {
        if (res.err === 200) {
          this.addStockList.push(StockCode);
          this.$toast('加入成功');
        } else {
          this.$toast('加入失败');
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.index-info {
  padding: 15px;
  .title {
    color: rgba(0, 0, 0, 0.9);
    font-size: 16px;
    font-weight: 600;
  }
  .tab {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background: #fff;
    padding: 4px 0;
    li {
      height: 25px;
      left: 0px;
      top: 0px;
      background: #fff;
      border: 0.5px solid #f5f6f9;
      border-radius: 4px;
      padding: 0 14px;
      font-weight: 400;
      font-size: 12px;
      line-height: 25px;
      color: #555;
      margin-right: 9px;
      margin: 4px 4px 4px 0;
    }
    .checkedClass {
      background: #eaf1ff;
      border: 1px solid #eaf1ff;
      color: #286df7;
    }
  }
  .lsmx {
    margin-top: 20px;
    line-height: 20px;
    .fc-title-sticky {
      ::v-deep {
        .van-sticky--fixed {
          left: 15px;
          right: 15px;
        }
      }
    }
    .title,
    .content-list {
      display: flex;
      align-items: center;
      background: #fff;
      li {
        width: 20%;
        font-weight: 400;
        font-size: 12px;
        color: #999;
        margin-bottom: 8px;
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          text-align: right;
        }
        .StockName {
          font-weight: 600;
          font-size: 14px;
          color: #555;
        }
        .StockCode {
          font-weight: 400;
          font-size: 12px;
          color: #999;
        }
        .add_btn,
        .del_btn {
          border-radius: 2px;
          padding: 2px 3px;
          font-size: 11px;
          font-weight: 400;
        }
        .add_btn {
          background: rgba(40, 109, 247, 0.06);
          color: #286df7;
        }

        .del_btn {
          background: rgba(153, 153, 153, 0.06);
          color: #999;
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title {
    color: #e4e9fe;
  }
  .lsmx {
    .fc-title-sticky {
      .title {
        background: #191a24;
        li {
          color: #6b7687;
        }
      }
    }
    .content-list {
      background: none;
      li {
        color: #e4e9fe;
        .StockName {
          color: #e4e9fe;
        }
        .StockCode {
          color: #6b7687;
        }
      }
    }
  }
}
</style>
